import EventClass from "common/utils/ui/event-class";

export default class DtfTileUI extends EventClass {
  constructor($container, uploadManagerInstance) {
    super({
      eventSelector: ".js-file-input",
      event: "change"
    });

    this.$container = $container;
    this.tileId = $container.dataset.tileId;
    this.percentage = 0;
    this.uploadManager = uploadManagerInstance;

    this.#attachLabelEventListeners();
  }

  get $fileInputs() {
    return this.$container.querySelectorAll(".js-file-input");
  }

  get $labels() {
    return this.$container.querySelectorAll('[data-testid="upload-design-button"]');
  }

  get $uploadContainers() {
    return this.$container.querySelectorAll(
      ".jiffytransfers-landing-v2-popular-dtf-transfers-section__upload-container"
    );
  }

  get $progressContainer() {
    return this.$container.querySelector(".js-upload-progress");
  }

  get $progressFill() {
    return this.$container.querySelector(".js-progress-fill");
  }

  get $progressText() {
    return this.$container.querySelector(".js-progress-text");
  }

  get $errorContainer() {
    return this.$container.querySelector(".js-upload-error");
  }

  get $fileName() {
    return this.$container.querySelector(".js-file-name");
  }

  #attachLabelEventListeners() {
    this.$labels.forEach($label => {
      $label.addEventListener("click", e => {
        if (this.uploadManager.isUploadActive(this.tileId)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
  }

  setErrorMessage(text) {
    if (this.$errorContainer) {
      this.$errorContainer.textContent = text;
      this.$errorContainer.classList.remove("hidden");
    }
    this.showUploadButtons();
  }

  hideError() {
    if (this.$errorContainer) {
      this.$errorContainer.classList.add("hidden");
      this.$errorContainer.textContent = "";
    }
  }

  showProgress(fileName = "") {
    if (this.$progressContainer) this.$progressContainer.classList.remove("hidden");
    this.#toggleUploadButtons(false);
    if (this.$fileName && fileName) this.$fileName.textContent = fileName;
    this.hideError();
  }

  hideProgress() {
    if (this.$progressContainer) this.$progressContainer.classList.add("hidden");
    this.#toggleUploadButtons(true);
    if (this.$fileName) this.$fileName.textContent = "";
  }

  showUploadButtons() {
    this.#toggleUploadButtons(true);
  }

  #toggleUploadButtons(show) {
    this.$uploadContainers.forEach(container => {
      const uploadContainer = container;
      if (show) {
        uploadContainer.classList.remove("hidden");
      } else {
        uploadContainer.classList.add("hidden");
      }
    });
  }

  setDisabled(disabled) {
    this.$labels.forEach($label => {
      const label = $label;
      if (disabled) {
        label.classList.add(
          "jiffytransfers-landing-v2-popular-dtf-transfers-section__upload-label--disabled"
        );
      } else {
        label.classList.remove(
          "jiffytransfers-landing-v2-popular-dtf-transfers-section__upload-label--disabled"
        );
      }
    });

    this.$fileInputs.forEach($input => {
      const input = $input;
      input.disabled = disabled;
    });
  }

  updateProgress(percentage, text) {
    this.percentage = percentage;
    if (this.$progressFill) this.$progressFill.style.width = `${percentage}%`;
    if (text && this.$progressText) this.$progressText.textContent = text;
  }
}
